import React from 'react'

import { ServiceCountTypeProvider } from '../UI/FormatProviders'
import DataGrid from '../UI/DataGrid'
import ServiceCategoryCard from './ServiceCategoryCard'

const ListServiceCategories = () => {
  const gridColumns = [
    { name: 'id', title: 'ID' },
    { name: 'projectTypeName', title: 'Project type' },
    { name: 'order', title: 'Order' },
    { name: 'name', title: 'Name' },
    { name: 'serviceCount', title: 'Number of services' }
  ]

  const gridRowMappingFn = serviceCategory => {
    const id = serviceCategory.id
    const {
      projectTypeName,
      order,
      name,
      serviceCount
    } = serviceCategory.attributes

    return {
      id: id,
      projectTypeName: projectTypeName,
      order: Number(order),
      name: name,
      serviceCount: Number(serviceCount)
    }
  }

  const gridSorting = [
    { columnName: 'projectTypeName', direction: 'asc' },
    { columnName: 'order', direction: 'asc' }
  ]

  const gridHiddenColumns = ['id']
  const tableColumnVisibilityExtensions = [
    { columnName: 'id', togglingEnabled: false },
    { columnName: 'name', togglingEnabled: false }
  ]

  const tableColumnExtensions = [
    { columnName: 'projectTypeName', width: 300 },
    { columnName: 'order', align: 'center', width: 65 },
    { columnName: 'serviceCount', width: 200 }
  ]

  // Formatted columns
  const typeProviders = [<ServiceCountTypeProvider for={['serviceCount']} />]

  // Details dialog style
  const detailsDialogStyle = {
    height: '90vh',
    maxHeight: 'none'
  }

  return (
    <DataGrid
      resourceAPIEndpoint="service-categories"
      resourceSingularName="Service category"
      resourcePluralName="Service categories"
      nameAttribute="name"
      clientRootPath="/service-categories"
      gridColumns={gridColumns}
      gridRowMappingFn={gridRowMappingFn}
      gridSorting={gridSorting}
      gridHiddenColumns={gridHiddenColumns}
      tableColumnVisibilityExtensions={tableColumnVisibilityExtensions}
      tableColumnExtensions={tableColumnExtensions}
      detailsCard={ServiceCategoryCard}
      typeProviders={typeProviders}
      detailsDialogStyle={detailsDialogStyle}
    />
  )
}

export default ListServiceCategories



// WEBPACK FOOTER //
// ./src/components/ServiceCategories/ListServiceCategories.jsx